import Role from "@mapmycustomers/shared/enum/Role";
import type User from "@mapmycustomers/shared/types/User";

export const isOwner = ({ role }: Pick<User, "role">) => role.key === Role.OWNER;
export const isManager = ({ role }: Pick<User, "role">) => role.key === Role.MANAGER;
export const isMember = ({ role }: Pick<User, "role">) => role.key === Role.MEMBER;
export const isReadOnly = ({ role }: Pick<User, "role">) =>
  role.key === Role.READ_ONLY || role.key === Role.READ_ONLY_WITH_EXPORTS;
